import { SensorType } from '../../../types/sensor-type';
import { BaseSensorWebComponent } from '../../../base/BaseSensorWebComponent';
import { AtlassianAuditController } from "../controller/AtlassianAuditController";

export class AtlassianAuditComponent extends BaseSensorWebComponent {
  public controller!: AtlassianAuditController;

  constructor() {
    super();
    this.sensorType = SensorType.ATLASSIAN_AUDIT;
    this.initialSetup({
      controllerConstructor: AtlassianAuditController,
    });
  }

  public setEnabled(isEnabled: boolean): void {
    this.controller.setEnabledAllFields(isEnabled);
  }
}
